export default "__VITE_ASSET__4722291a__"